import { type PropsWithChildren } from "react";

import clsx from "clsx";

import {
  isPositiveChange,
  type BenchmarkIndicatorRow,
} from "@features/universal-benchmarks";

interface Props {
  benchmarkKpi: BenchmarkIndicatorRow;
}

export const BenchmarkBadge = ({
  benchmarkKpi,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={clsx(
        "font-mono text-xs rounded h-5 flex items-center px-1.5 text-nowrap",
        {
          "text-v2-action-positive-hover bg-v2-alien/400/10%":
            isPositiveChange(benchmarkKpi),
          "text-v2-action-negative-hover bg-v2-mars/400/10%":
            !isPositiveChange(benchmarkKpi),
        },
      )}
    >
      {children}
    </div>
  );
};
